angular.module('components.caImportRowsGrid', [])
    .component('caImportRowsGrid', {
        templateUrl: 'main/product/productimporteditor/components/importrowsgrid.component.tpl.html',
        controllerAs: 'vm',
        bindings: {
            importFile: '=',
            validationErrors: '=',
            checkResults: '=',
            selectedFileRowIds: '=',
            tenantCurrency: '<',
            onGroupRowChanged: '&',
            validationErrorChangeCount: '=',
            currencies: '<',
            componentRegistrationHandler: '&'
        },
        controller: controller
    });

// @ngInject
function controller($scope, $translate, ToasterService, FileDataImportApiServiceV2, loadSpinnerService, $q) {
    var vm = this;

    //Properties
    var lastFocusedFileRow = {};
    var lastBlurredFileRow = {};
    var highlightingPriorities = [
        { name: 'none', priority: 0 },
        { name: 'foundData', priority: 1 },
        { name: 'warning', priority: 2 },
        { name: 'error', priority: 3 }
    ];
    vm.numberOfLoadingRows = 0;
    vm.currentDisplayedGroups = [];
    vm.itemGroupOptions = [];
    vm.CompanyOptions = [];
    vm.departmentOptions = [];
    vm.subCategoryOptions = [];
    vm.articleTypeOptions = [];
    vm.articleCollectionOptions = [];
    vm.orderCollectionOptions = [];
    vm.displayedColumns = [];
    vm.displayedGroups = [];
    vm.currentPage = 1;
    vm.itemsPerPage = 10;
    vm.fixedItemsPerPageChoices = [5, 10, 15, 20, 25];
    // Data model to convey which grid columns exists between the grid, grid rows and grid cells.
    vm.gridColumnIdentifiers = [];
    vm.groupingLevels = [
        { id: 1,  label: 'productimport.none',                  groupingType: 'none'    },
        { id: 2,  label: 'productimport.product',               groupingType: 'article' },
        { id: 3,  label: 'productimport.orderNumberExternal',   groupingType: 'ordernumberexternal' },
        { id: 4,  label: 'productimport.department',            groupingType: 'department' },
        { id: 5,  label: 'productimport.subCategory',           groupingType: 'subcategory' },
        { id: 6,  label: 'productimport.itemgroup',             groupingType: 'itemGroup' },
        { id: 7,  label: 'productimport.intrastat',             groupingType: 'intrastat' },
        { id: 8,  label: 'productimport.articleCollection',     groupingType: 'articleCollection' },
        { id: 9,  label: 'productimport.orderCollection',       groupingType: 'orderCollection' },
        { id: 10, label: 'productimport.articleType',           groupingType: 'articleTypeName' }
    ];
    vm.currentGroupingLevel = vm.groupingLevels[1];
    vm.isAllowedToImportSku = false;

    //Methods
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;
    vm.deleteFileRow = deleteFileRow;
    vm.textInputBoxFocused = textInputBoxFocused;
    vm.textInputBoxBlurred = textInputBoxBlurred;
    vm.fileRowChanged = fileRowChanged;
    vm.groupRowChanged = groupRowChanged;
    vm.deleteGroupRow = deleteGroupRow;
    vm.saveFileRow = saveFileRow;
    vm.saveGroupRow = saveGroupRow;
    vm.updatePage = updatePage;
    vm.updateValue = updateValue;
    vm.getRowInputStyle = getRowInputStyle;
    vm.getRowInputClass = getRowInputClass;
    vm.getInputTooltip = getInputTooltip;
    vm.getPriceInTenantCurrency = getPriceInTenantCurrency; 
    vm.filterChoices = filterChoices;
    vm.isInputReadOnly = isInputReadOnly;
    vm.cleanBarcodes = cleanBarcodes;


    function onInit() {
        
        if(vm.importFile.importType == 'product')
        {
            // Group without Order options
            vm.groupingLevels = [
                { id: 1,  label: 'productimport.none',                  groupingType: 'none'    },
                { id: 2,  label: 'productimport.product',               groupingType: 'article' },
                { id: 3,  label: 'productimport.department',            groupingType: 'department' },
                { id: 4,  label: 'productimport.subCategory',           groupingType: 'subcategory' },
                { id: 5,  label: 'productimport.itemgroup',             groupingType: 'itemGroup' },
                { id: 6,  label: 'productimport.intrastat',             groupingType: 'intrastat' },
                { id: 7,  label: 'productimport.articleCollection',     groupingType: 'articleCollection' },
                { id: 8, label: 'productimport.articleType',           groupingType: 'articleTypeName' }
            ];
        }

        FileDataImportApiServiceV2.getTenantConfig().then(function(response) {
            vm.isAllowedToImportSku = response.data.isAllowedToImportSku;
        });

        setGridColumnIdentifiers();
        getDropdownSelections();
        sortFileRows(vm.importFile);
        setDisplayedRows(vm.importFile.importRows);
        vm.displayedColumns = vm.gridColumnIdentifiers;
        vm.currentDisplayedGroups = [];

        validateImportFileWithId(vm.importFile.id);

        vm.componentRegistrationHandler({ component: this });

        // Watch for new filter information from outside this component
        $scope.$watch(function() { return vm.selectedFileRowIds; }, function() {
            if (vm.selectedFileRowIds.length !== 0) {
                var relevantFileRows = _.filter(vm.importFile.importRows, function(fileRow) {
                    return _.find(vm.selectedFileRowIds, function(id) {
                        return id === fileRow.id;
                    });
                });
                setDisplayedRows(relevantFileRows);
            } else {
                setDisplayedRows(vm.importFile.importRows);
            }
        });

        $scope.$watch(function() { return vm.currentGroupingLevel; }, function(oldValue, newValue) {
            if (oldValue !== newValue) {
                vm.selectedFileRowIds = [];
                setDisplayedRows(vm.importFile.importRows);
            }
        });

        $scope.$watch(function() { return vm.numberOfLoadingRows; }, function(newValue, oldValue) {
            if (newValue !== oldValue && newValue === 0) { // If all rows are done loading
                validateImportFileWithId(vm.importFile.id);
            }
        });

        $scope.$watch(function() { return vm.validationErrorChangeCount; }, function(newValue, oldValue) {
            if (newValue !== oldValue) {
                _.forEach(vm.currentDisplayedGroups, function(g) {
                    handleInformationHighlighting(g);
                });
            }
        });

        $scope.$watch(function() { return vm.itemsPerPage; }, function(newValue, oldValue) {
            if (newValue && newValue !== oldValue) {
                updatePage();
            }
        });

        _.forEach(vm.groupingLevels, function(g) {
            g.label = $translate.instant(g.label);
        });
    }

    function onChanges(changes) {

    }

    function onDestroy() {

    }

    function validateImportFileWithId(importFileId) {
        loadSpinnerService.start('mainSpinner', { message: $translate.instant('productimport.loadingValidatingImportRows') });
        var promises = [];

        var promise = FileDataImportApiServiceV2.validateImportFileWithId(importFileId);
        promises.push(promise);

        promise = FileDataImportApiServiceV2.checkImportFileDataExistence(importFileId);
        promises.push(promise);

        $q.all(promises).then(function(responses) {
            var validationResults = responses[0];
            handleValidationErrors(validationResults);

            if (vm.checkResults) {
                vm.checkResults.length = 0;
            } else {
                vm.checkResults = [];
            }
            _.forEach(responses[1], function(res) {
                vm.checkResults.push(res);
            });
            _.forEach(vm.displayedGroups, function(groupRow) {
                handleInformationHighlighting(groupRow);
            });

        }, function(error) {
            ToasterService.showError($translate.instant('productimport.couldntValidateFile'));
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner');
        });

    }

    function sortFileRows(importFile) {
        importFile.importRows = _.orderBy(importFile.importRows, function(importRow) {
            return importRow.alternativeArticleNumber;
        }, function(importRow) {
            return importRow.variant1Name;
        }, function(importRow) {
            return importRow.variant2Name;
        });
    }

    // Change what rows are displayed in the grid
    function setDisplayedRows(importRows) {
        var relevantEditProperties = [];

        if(vm.currentGroupingLevel.groupingType === 'none'){
            // No grouping
            groupRowsByImportFileRow(importRows);
            return;
        }
        

        if (vm.currentGroupingLevel.groupingType === 'article') {
            relevantEditProperties = [
                'alternativeArticleNumber', 'articleName', 'articleDescription', 'articleTypeName', 'itemGroupCode', 'departmentCode', 'purchaseCost',
                'salesPrice', 'previousPrice', 'currencyCode', 'subCategory', 'articleCollectionCode', 'orderCollectionCode', 'numberOfRows', 'companyCode', 'countryCode'
            ];
        } else if (vm.currentGroupingLevel.groupingType === 'ordernumberexternal') {
            relevantEditProperties = [
                'orderNumberExternal', 'orderCollectionCode'
            ];
        } else if (vm.currentGroupingLevel.groupingType === 'department') {
            relevantEditProperties = [
                'departmentCode'
            ];
        } else if (vm.currentGroupingLevel.groupingType === 'subcategory') {
            relevantEditProperties = [
                'subCategory'
            ];
        } else if (vm.currentGroupingLevel.groupingType === 'articleTypeName') {
            relevantEditProperties = [
                'articleTypeName'
            ];
        } else if (vm.currentGroupingLevel.groupingType === 'itemGroup') {
            relevantEditProperties = [
                'itemGroupCode', 'companyCode'
            ];
        } else if (vm.currentGroupingLevel.groupingType === 'intrastat') {
            relevantEditProperties = [
                'intrastatCode'
            ];
        } else if (vm.currentGroupingLevel.groupingType === 'articleCollection') {
            relevantEditProperties = [
                'articleCollectionCode'
            ];
        } else if (vm.currentGroupingLevel.groupingType === 'orderCollection') {
            relevantEditProperties = [
                'orderCollectionCode'
            ];
        }

        groupRowsByRelevantEditProperties(importRows, relevantEditProperties);
    }

    // When one of the input text boxes of the grid is focused.
    function textInputBoxFocused(editPropertyName, fileRow) {
        var lastRowExists = lastFocusedFileRow !== undefined && lastFocusedFileRow.id !== undefined;

        if (lastRowExists && lastFocusedFileRow.id !== fileRow.id && !lastBlurredFileRow.isPristine) {
            // validateGroupRow(lastBlurredFileRow);
            saveGroupRow(lastBlurredFileRow);
        }
        lastFocusedFileRow = fileRow;
    }

    function textInputBoxBlurred(editPropertyName, fileRow) {
        lastBlurredFileRow = fileRow;
    }

    // Remove a row from the import file from the local data model
    function deleteFileRow(fileRow) {
        fileRow.isLoading = true;
        vm.numberOfLoadingRows = vm.numberOfLoadingRows + 1;
        var promise = FileDataImportApiServiceV2.deleteFileRow(fileRow);

        promise.then(function(result) {
            fileRow.isPristine = true;
            _.remove(vm.importFile.importRows, function(row) {
                return row.id === fileRow.id;
            });
        }, function(error) {
            ToasterService.showError($translate.instant('productimport.couldNotSaveFileRow'));
        }).finally(function () {
            vm.numberOfLoadingRows = vm.numberOfLoadingRows - 1;
            fileRow.isLoading = false;
        });
        return promise;
    }

    function saveFileRow(fileRow) {
        fileRow.isLoading = true;
        vm.numberOfLoadingRows = vm.numberOfLoadingRows + 1;
        var promise = FileDataImportApiServiceV2.updateFileRow(fileRow);

        promise.then(function(result) {
            fileRow.isPristine = true;
        }, function(error) {
            ToasterService.showError($translate.instant('productimport.couldNotSaveFileRow'));
        }).finally(function() {
            fileRow.isLoading = false;
            vm.numberOfLoadingRows = vm.numberOfLoadingRows - 1;
        });
        return promise;
    }

    // Note down which file rows has changed since last save.
    function fileRowChanged(fileRow) {
        fileRow.isPristine = false;
        if (vm.onGroupRowChanged) {
            vm.onGroupRowChanged();
        }
    }

    function groupRowChanged(groupRow, propertyName) {
        if (vm.onGroupRowChanged) {
            vm.onGroupRowChanged();
        }
        groupRow.isPristine = false;
        _.forEach(groupRow.fileRows, function(fileRow) {
            fileRow.isPristine = false;
            fileRow[propertyName] = groupRow[propertyName];
        });
    }

    function resetValidationErrors() {
        vm.validationErrors.length = 0;
        vm.validationErrors = [];
    }

    // Organize validation errors
    function handleValidationErrors(validationResults) {
        vm.validationErrors = [];
        _.forEach(validationResults, function(res) {
            var fileRow = res.importRow;
            var newValidationErrors = res.validationErrors;
            _.forEach(newValidationErrors, function(validationError) {
                var validationErrorRow = _.find(vm.validationErrors, function(err) { return err.displayMessage === validationError.displayMessage; });
                if (validationErrorRow === undefined) {
                    validationErrorRow = validationError;
                    validationErrorRow['fileRows'] = [];
                    vm.validationErrors.push(validationErrorRow);
                }

                if (!_.find(validationErrorRow.fileRows, function(fr) { return fr.id === fileRow.id; })) {
                    validationErrorRow.fileRows.push(fileRow);
                }
            });
        });
    }

    function groupRowsByRelevantEditProperties(importRows, relevantEditProperties) {
        vm.displayedGroups = [];

        vm.displayedColumns = _.filter(vm.gridColumnIdentifiers, function(identifier) {
            return identifier.editPropertyName === undefined ||
                   _.find(relevantEditProperties, function(p) { return p === identifier.editPropertyName; });
        });

        var groupings = _.groupBy(importRows, function(importRow) {
            var groupingString = "";
            _.forEach(relevantEditProperties, function(propertyName) {
                groupingString += importRow[propertyName];
            });
            return groupingString;
        });

        var groupingKeys = Object.keys(groupings);
        var counter = 0;
        _.forEach(groupingKeys, function(key) {
            var groupElements = groupings[key];
            var groupRow = {
                fileRows: groupElements,
                isPristine: true,
                isLoading: false,
                id: counter++,
                currencyCode: (groupElements !== undefined) ? groupElements[0].currencyCode : "?",
                tenantCurrencyCode: vm.tenantCurrency.code,
                numberOfRows: groupElements.length
            };
            vm.displayedGroups.push(groupRow);

            _.forEach(vm.displayedColumns, function(identifier) {
                if (identifier.editPropertyName !== undefined) {
                    var importRow = groupRow.fileRows[0];
                    groupRow[identifier.editPropertyName] = importRow[identifier.editPropertyName];
                }
            });
            handleInformationHighlighting(groupRow);
        });

        updatePage();
    }

    function groupRowsByImportFileRow(importRows) {
        vm.displayedColumns = vm.gridColumnIdentifiers;
        vm.displayedGroups = [];
        var counter = 0;

        _.forEach(importRows, function(importRow) {
            var group = {
                fileRows: [importRow],
                isPristine: true,
                isLoading: false,
                id: counter++,
                numberOfRows: 1,
                currencyCode: (importRow !== undefined) ? importRow.currencyCode : "?",
                tenantCurrencyCode: vm.tenantCurrency.code
            };
            _.forEach(vm.displayedColumns, function(identifier) {
                if (identifier.editPropertyName !== undefined) {
                    group[identifier.editPropertyName] = importRow[identifier.editPropertyName];
                }
            });
            vm.displayedGroups.push(group);

            handleInformationHighlighting(group);
        });

        updatePage();
    }

    function saveGroupRow(groupRow) {
        groupRow.isLoading = true;
        var promises = [];
        _.forEach(groupRow.fileRows, function(fileRow) {
            var promise = saveFileRow(fileRow);
            promises.push(promise);
        });
        $q.all(promises).finally(function() {
            groupRow.isPristine = true;
            groupRow.isLoading = false;
        });
    }

    function deleteGroupRow(groupRow) {
        _.forEach(groupRow.fileRows, function(fileRow) {
            deleteFileRow(fileRow);
        });
        _.remove(vm.displayedGroups, function(gr) {
            return gr.id === groupRow.id;
        });

        _.remove(vm.currentDisplayedGroups, function(gr) {
            return gr.id === groupRow.id;
        });
    }

    function updatePage() {
        var page = [];
        var sourceCollection = vm.displayedGroups;
        var itemsPerPage = vm.itemsPerPage;
        var currentPage = vm.currentPage;

        var numberOfItems = Math.min(itemsPerPage, sourceCollection.length);
        var startPosition = itemsPerPage * (currentPage - 1);
        var endPosition = (startPosition + numberOfItems) - 1;

        for (var i = startPosition; i <= endPosition; i++) {
            if (i >= sourceCollection.length) {
                continue;
            }
            page.push(sourceCollection[i]);
        }

        vm.currentDisplayedGroups = page;
    }

    function getDropdownSelections() {
        loadSpinnerService.start('mainSpinner');

        var onlyCurrentCollections = true;

        FileDataImportApiServiceV2.getItemGroupsOnFileId(vm.importFile.id).then(function(result) {
            vm.itemGroupOptions = [];

            _.forEach(result, function(ig) {
                vm.itemGroupOptions.push({
                value: ig.itemGroupCode,
                fullName: ig.itemGroupCode + ' ' + ig.itemGroupLongName,
                companyNamnes: ig.brand.companies.map(function(company) { return company.companyName || ""; })
            }); });

            var itemGroupElement = _.find(vm.gridColumnIdentifiers, function(e) { return e.editPropertyName === 'itemGroupCode'; });
            if (itemGroupElement) {
                itemGroupElement.selectionElements = vm.itemGroupOptions;
            }
        }, function(error) {
            ToasterService.showError(error.message);
        });

        FileDataImportApiServiceV2.getDepartments().then(function(result) {

            vm.departmentOptions = [];
            _.forEach(result, function(d) { vm.departmentOptions.push({ value: d.departmentCode, fullName: '' + d.departmentCode + ' ' + d.departmentDescription }); });
            var departmentElement = _.find(vm.gridColumnIdentifiers, function(ci) { return ci.editPropertyName === 'departmentCode'; });
            if (departmentElement) {
                departmentElement.selectionElements = vm.departmentOptions;
            }
        }, function(error) {
            ToasterService.showError(error.message);
        });

        FileDataImportApiServiceV2.getSubCategories().then(function(result) {
            vm.subCategoryOptions = [];
            _.forEach(result, function(sc) { vm.subCategoryOptions.push({ value: sc.subCategoryCode, fullName: '' + sc.subCategoryCode + ' ' + sc.subCategoryName }); });
            var subCategoryElement = _.find(vm.gridColumnIdentifiers, function(ci) { return ci.editPropertyName === 'subCategory'; });
            if (subCategoryElement) {
                subCategoryElement.selectionElements = vm.subCategoryOptions;
            }
        }, function(error) {
            ToasterService.showError(error.message);
        });

        FileDataImportApiServiceV2.getArticleTypes().then(function(result) {
            vm.articleTypeOptions = [];
            _.forEach(result, function(sc) { vm.articleTypeOptions.push({ value: sc.articleTypeName, fullName: '' + sc.articleTypeName + ' (' + sc.articleSystemType + ')' }); });
            var articleTypeElement = _.find(vm.gridColumnIdentifiers, function(ci) { return ci.editPropertyName === 'articleTypeName'; });
            if (articleTypeElement) {
                articleTypeElement.selectionElements = vm.articleTypeOptions;
            }
        }, function(error) {
            ToasterService.showError(error.message);
        });

        FileDataImportApiServiceV2.getOrderCollections(onlyCurrentCollections).then(function(result) {
            vm.orderCollectionOptions = [];
            _.forEach(result, function(oc) { vm.orderCollectionOptions.push({ value: '' + oc.collectionCode, fullName: '' + oc.collectionCode + ' ' + oc.collectionDescription }); });
            var orderCollectionElement = _.find(vm.gridColumnIdentifiers, function(ci) { return ci.editPropertyName === 'orderCollectionCode'; });
            if (orderCollectionElement) {
                orderCollectionElement.selectionElements = vm.orderCollectionOptions;
            }
        }, function(error) {
            ToasterService.showError(error.message);
        });

        FileDataImportApiServiceV2.getArticleCollections(onlyCurrentCollections).then(function(result) {
            vm.articleCollectionOptions = [];
            _.forEach(result, function(ac) { vm.articleCollectionOptions.push({ value: '' + ac.collectionCode, fullName: '' + ac.collectionCode + ' ' + ac.collectionDescription }); });
            var articleCollectionElement = _.find(vm.gridColumnIdentifiers, function(ci) { return ci.editPropertyName === 'articleCollectionCode'; });
            if (articleCollectionElement) {
                articleCollectionElement.selectionElements = vm.articleCollectionOptions;
            }
        }, function(error) {
            ToasterService.showError(error.message);
        });

        FileDataImportApiServiceV2.getCompanies().then(function(result) {
            vm.CompanyOptions = [];
            _.forEach(result, function(company) {
                vm.CompanyOptions.push({ value: company.companyName, fullName: '' + company.companyName });
            });
            var CompanyElement = _.find(vm.gridColumnIdentifiers, function(e) { return e.editPropertyName === 'companyCode'; });
            if (CompanyElement) {
                CompanyElement.selectionElements = vm.CompanyOptions;
            }
        }, function(error) {
            ToasterService.showError(error.message);
        });

        FileDataImportApiServiceV2.getSalesChannels().then(function(result) {
            vm.saleChannelOptions = [];
            _.forEach(result, function(salesChannel) {
                vm.saleChannelOptions.push({id: salesChannel.id, value: salesChannel.salesChannelCode, fullName: `${salesChannel.salesChannelCode} ${salesChannel.salesChannelDescription}`});
            });
            var saleChannelElement = _.find(vm.gridColumnIdentifiers, function(e) { return e.editPropertyName === 'saleChannels'; });
            if (saleChannelElement) {
                saleChannelElement.selectionElements = vm.saleChannelOptions;
            }
        }, function(error) {
            ToasterService.showError(error.message);
        });

        FileDataImportApiServiceV2.getCountries().then(function(result) {
            vm.countryOptions = [];
            _.forEach(result, function(country) {
                vm.countryOptions.push({id: country.id, value: country.code, fullName: `${country.code} ${country.name}`});
            });
            var countryElement = _.find(vm.gridColumnIdentifiers, function(e) { return e.editPropertyName === 'countryCode'; });
            if (countryElement) {
                countryElement.selectionElements = vm.countryOptions;
            }
        }, function(error) {
            ToasterService.showError(error.message);
        });

        $q.all().finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function updateValue(groupRow, editProperty, value) {
        if (editProperty === 'companyCode') {
            groupRow['itemGroupCode'] = "";
            _.forEach(groupRow.fileRows, function(fileRow) {
                fileRow['itemGroupCode'] = "";
            });
        }

        groupRow[editProperty] = '' + value;
        _.forEach(groupRow.fileRows, function(fileRow) {
            fileRow[editProperty] = '' + value;
            fileRow.isPristine = false;
        });

        groupRow.isPristine = false;
    }

    function handleInformationHighlighting(groupRow) {
        _.forEach(groupRow.fileRows, function(fileRow) {
            var relatedCheckRow = _.find(vm.checkResults, function(chk) { return chk.importRowId === fileRow.id; });
            var relatedErrorRows = _.filter(vm.validationErrors, function(error) {
                var hasError = _.some(error.fileRows, function(errorFileRow) { return errorFileRow.id === fileRow.id; });
                return hasError;
            });
            setHighlightingAndType(relatedCheckRow, relatedErrorRows, fileRow, groupRow);
        });

        function setHighlightingAndType(dataCheckRow, validationErrors, fileRow, groupRow) {
            groupRow['highlighting'] = [];

            groupRow.highlighting.push(consolidateDataCheckAndValidationErrors('alternativeArticleNumber', dataCheckRow, validationErrors, fileRow, groupRow));
            groupRow.highlighting.push(consolidateDataCheckAndValidationErrors('articleName', dataCheckRow, validationErrors, fileRow, groupRow));
            groupRow.highlighting.push(consolidateDataCheckAndValidationErrors('articleDescription', dataCheckRow, validationErrors, fileRow, groupRow));
            groupRow.highlighting.push(consolidateDataCheckAndValidationErrors('articleTypeName', dataCheckRow, validationErrors, fileRow, groupRow));
            groupRow.highlighting.push(consolidateDataCheckAndValidationErrors('itemGroupCode', dataCheckRow, validationErrors, fileRow, groupRow));
            groupRow.highlighting.push(consolidateDataCheckAndValidationErrors('variant1Name', dataCheckRow, validationErrors, fileRow, groupRow));
            groupRow.highlighting.push(consolidateDataCheckAndValidationErrors('variant2Name', dataCheckRow, validationErrors, fileRow, groupRow));
            groupRow.highlighting.push(consolidateDataCheckAndValidationErrors('locationCode', dataCheckRow, validationErrors, fileRow, groupRow));
            groupRow.highlighting.push(consolidateDataCheckAndValidationErrors('departmentCode', dataCheckRow, validationErrors, fileRow, groupRow));
            groupRow.highlighting.push(consolidateDataCheckAndValidationErrors('quantity', dataCheckRow, validationErrors, fileRow, groupRow));
            groupRow.highlighting.push(consolidateDataCheckAndValidationErrors('purchaseCost', dataCheckRow, validationErrors, fileRow, groupRow));
            groupRow.highlighting.push(consolidateDataCheckAndValidationErrors('salesPrice', dataCheckRow, validationErrors, fileRow, groupRow));
            groupRow.highlighting.push(consolidateDataCheckAndValidationErrors('previousPrice', dataCheckRow, validationErrors, fileRow, groupRow));
            groupRow.highlighting.push(consolidateDataCheckAndValidationErrors('subCategory', dataCheckRow, validationErrors, fileRow, groupRow));
            groupRow.highlighting.push(consolidateDataCheckAndValidationErrors('intrastatCode', dataCheckRow, validationErrors, fileRow, groupRow));
            groupRow.highlighting.push(consolidateDataCheckAndValidationErrors('barcode', dataCheckRow, validationErrors, fileRow, groupRow));
            if(vm.isAllowedToImportSku){
                groupRow.highlighting.push(consolidateDataCheckAndValidationErrors('externalSku', dataCheckRow, validationErrors, fileRow, groupRow));
            }
            groupRow.highlighting.push(consolidateDataCheckAndValidationErrors('articleCollectionCode', dataCheckRow, validationErrors, fileRow, groupRow));
            groupRow.highlighting.push(consolidateDataCheckAndValidationErrors('orderCollectionCode', dataCheckRow, validationErrors, fileRow, groupRow));
            groupRow.highlighting.push(consolidateDataCheckAndValidationErrors('companyCode', dataCheckRow, validationErrors, fileRow, groupRow));
        }

        function consolidateDataCheckAndValidationErrors(propertyName, dataCheckRow, validationErrors, fileRow, groupRow) {
            var highlightRow = {
                propertyName: propertyName,
                highlightType: _.minBy(highlightingPriorities, function(p) { return p.priority; }),
                displayMessage: ''
            };
            var dataCheckMatchesRow = (dataCheckRow !== undefined && groupRow !== undefined && dataCheckRow.importRowId === fileRow.id);

            var validationErrorsForThisProperty = _.filter(validationErrors, function (e) {
                return !e.hide && _.some(e.properties, function(p) { return p.toLowerCase() === propertyName.toLowerCase(); });
            });

            var validationErrorMatchesRow = (validationErrorsForThisProperty.length !== 0);

            if (validationErrorMatchesRow) {
                _.forEach(validationErrorsForThisProperty, function(err) {

                    if(highlightRow.displayMessage !== '')
                        highlightRow.displayMessage += ' | ';

                    highlightRow.displayMessage += $translate.instant(err.displayMessage);
                    highlightRow.highlightType = getHighestHighlightPriority(highlightRow.highlightType, err.severity);
                });
            } else if (dataCheckMatchesRow) {

                // barcode and sku exist on different variants
                var shouldShowError = ((propertyName === 'barcode' || propertyName === 'externalSku') && dataCheckRow.BarcodeAndSkuOnDifferentArticles);

                if (shouldShowError) {
                    highlightRow.highlightType = _.find(highlightingPriorities, function(p) { return p.name === 'error'; });
                    highlightRow.displayMessage = getDataAlreadyExistsErrorMessage(propertyName, groupRow);
                }


                var shouldHighlight = (propertyName === 'alternativeArticleNumber' && dataCheckRow.alternativeArticleNumberExists) ||
                                    (propertyName === 'barcode' && dataCheckRow.barcodeExists) || (propertyName === 'externalSku' && dataCheckRow.externalSkuExists);
                if (shouldHighlight && !shouldShowError) {
                    highlightRow.highlightType = _.find(highlightingPriorities, function(p) { return p.name === 'foundData'; });
                    highlightRow.displayMessage = getDataAlreadyExistsMessage(propertyName, groupRow);
                }
            }

            return highlightRow;
        }
    }

    function shouldShowBarcodeOrSKUError(dataCheckRow){
        if(propertyName === 'barcode' && dataCheckRow.barcodeExists && dataCheckRow.barcode && dataCheckRow.barcode !== '')
            return false
    }

    function getHighestHighlightPriority(currentPriority, errorSeverity) {
        var priority = _.minBy(highlightingPriorities, function(p) { return p.priority; });
        var errorPriority = _.find(highlightingPriorities, function(p) { return p.name.toLowerCase() === errorSeverity.toLowerCase(); });
        if (errorPriority === undefined) {
            errorPriority = priority;
        }
        if (priority.priority < errorPriority.priority) {
            priority = errorPriority;
        }
        return priority;
    }

    function getRowInputStyle(editProperty, groupRow) {
        var style = {};
        var green = '#22BB22';
        var orange = '#e58d22';
        var red = '#e8563c';
        var white ='#ffffff';
        var black = '#000000';
        var transparent = 'transparent';
        var borderWidth = '2px';
        var borderStyle = 'solid';

        var highlightElement = _.find(groupRow.highlighting, function(h) { return h.propertyName === editProperty; });

        if (highlightElement !== undefined) {
            style['border-width'] = borderWidth;
            style['border-style'] = borderStyle;
            if (highlightElement.highlightType.name === 'error') {
                style['border-color'] = red;
                style['background-color'] = red;
                style['color'] = white;
            } else if (highlightElement.highlightType.name === 'warning') {
                style['border-color'] = orange;
                style['background-color'] = orange;
                style['color'] = white;
            } else if (highlightElement.highlightType.name === 'foundData') {
                style['border-color'] = green;
                style['background-color'] = green;
                style['color'] = white;
            } else if (highlightElement.highlightType.name === 'none') {
                style['border-width'] = '0px';
                style['background-color'] = transparent;
                style['color'] = black;
            }
        }

        var doubleWidthColumns = [
            'alternativeArticleNumber',
            'articleName',
            'articleDescription',
            'variant1Name',
            'barcode'
        ];
        if (doubleWidthColumns.indexOf(editProperty) > -1) {
            style['width'] = 'max-content';
            style['min-width'] = '150px';
        }

        return style;
    }

    function getRowInputClass(editProperty, groupRow) {
        var caClass = '';

        var highlightElement = _.find(groupRow.highlighting, function(h) { return h.propertyName === editProperty; });

        if (highlightElement !== undefined) {
            if (highlightElement.highlightType.name === 'error') {
                caClass = 'caUiSelectErrorBackground';
            } else if (highlightElement.highlightType.name === 'warning') {
                caClass = 'caUiSelectWarningBackground';
            } else if (highlightElement.highlightType.name === 'foundData') {
                caClass = 'caUiSelectFoundDataBackground';
            } else if (highlightElement.highlightType.name === 'none') {
                caClass = '';
            }
        }

        return caClass;
    }

    function getDataAlreadyExistsMessage(editProperty, groupRow) {
        var tooltipText = '';

        if (editProperty === 'alternativeArticleNumber') {
            tooltipText = $translate.instant('productimport.productAlreadyExists');
        }
        if (editProperty === 'barcode') {
            tooltipText = $translate.instant('productimport.barcodeAlreadyExists');
        }
        if (editProperty === 'externalSku') {
            tooltipText = $translate.instant('productimport.skuAlreadyExists');
        }

        return tooltipText;
    }

    function getDataAlreadyExistsErrorMessage(editProperty) {
        var tooltipText = '';

        if (editProperty === 'barcode') {
            tooltipText = $translate.instant('productimport.SkuAndBarcodeInDifferentArticles');
        }
        if (editProperty === 'externalSku') {
            tooltipText = $translate.instant('productimport.SkuAndBarcodeInDifferentArticles');
        }

        return tooltipText;
    }

    function getInputTooltip(editProperty, groupRow) {
        var message = '';
        var highlightElement = _.find(groupRow.highlighting, function(h) { return h.propertyName === editProperty; });
        if (highlightElement !== undefined) {
            message = highlightElement.displayMessage;
            if (highlightElement.propertyName === 'itemGroupCode' && message === '' && vm.itemGroupOptions.length > 0 && groupRow.itemGroupCode) {
                var itemGroup = _.find(vm.itemGroupOptions, function(o) { return o.value === groupRow.itemGroupCode; });
                if (itemGroup !== undefined) {
                    message = itemGroup.fullName;
                } else {
                    message = 'Itemgroup \'' + groupRow.itemGroupCode + '\' was not found';
                }
            } else if (highlightElement.propertyName === 'departmentCode' && message === '' && vm.departmentOptions.length > 0 && groupRow.departmentCode) {
                var department = _.find(vm.departmentOptions, function(o) { return o.value === groupRow.departmentCode; });
                if (department !== undefined) {
                    message = department.fullName;
                } else {
                    message = 'Department \'' + groupRow.departmentCode + '\' was not found';
                }
            } else if (highlightElement.propertyName === 'subCategory' && message === '' && vm.subCategoryOptions.length > 0 && groupRow.subCategory) {
                var subCategory = _.find(vm.subCategoryOptions, function(o) { return o.value === groupRow.subCategory; });
                if (subCategory !== undefined) {
                    message = subCategory.fullName;
                } else {
                    message = 'Subcategory \'' + groupRow.subCategory + '\' was not found';
                }
            } else if (highlightElement.propertyName === 'articleTypeName' && message === '' && vm.articleTypeOptions.length > 0 && groupRow.articleTypeName) {
                var articleType = _.find(vm.articleTypeOptions, function(o) { return o.value === groupRow.articleTypeName; });
                if (articleType !== undefined) {
                    message = articleType.fullName;
                } else {
                    message = 'Product type \'' + groupRow.articleTypeName + '\' was not found';
                }
            } else if (highlightElement.propertyName === 'articleCollectionCode' && message === '' && vm.articleCollectionOptions.length > 0 && groupRow.articleCollectionCode) {
                var articleCollection = _.find(vm.articleCollectionOptions, function(o) { return o.value === groupRow.articleCollectionCode; });
                if (articleCollection !== undefined) {
                    message = articleCollection.fullName;
                } else {
                    message = 'Product collection \'' + groupRow.articleCollectionCode + '\' was not found';
                }
            } else if (highlightElement.propertyName === 'orderCollectionCode' && message === '' && vm.orderCollectionOptions.length > 0 && groupRow.orderCollectionCode) {
                var orderCollection = _.find(vm.orderCollectionOptions, function(o) { return o.value === groupRow.orderCollectionCode; });
                if (orderCollection !== undefined) {
                    message = orderCollection.fullName;
                } else {
                    message = 'Order collection \'' + groupRow.orderCollectionCode + '\' was not found';
                }
            }
        }

        var doubleWidthColumns = [
            'alternativeArticleNumber',
            'articleName',
            'articleDescription',
            'variant1Name',
            'barcode'
        ];
        if (doubleWidthColumns.indexOf(editProperty) > -1 &&
            groupRow[editProperty] &&
            groupRow[editProperty].length > 30 &&
            message.length === 0
        ) {
            message = groupRow[editProperty];
        }

        return message;
    }

    function getPriceInTenantCurrency(editProperty, groupRow) {
        var rowCurrencyCode = groupRow.currencyCode;
        var rowCurrency = _.find(vm.currencies, function(currency) { return currency.code === rowCurrencyCode });
        var foreignPrice = groupRow[editProperty]
        var tenantDefaultCurrency = vm.tenantCurrency;
        var shouldCalculateLocalCurrency = (editProperty === 'purchaseCost');

        if (tenantDefaultCurrency.id != rowCurrency.id && shouldCalculateLocalCurrency) 
        {
            return (foreignPrice * rowCurrency.currencyRate).toString() + ` ${tenantDefaultCurrency.code}` ;
        }
        return foreignPrice + ` ${tenantDefaultCurrency.code}`;
    }

    function filterChoices(collection, editProperty, groupRow) {
        if (editProperty === 'itemGroupCode') {
            var companyName = groupRow['companyCode'];
            if (companyName !== undefined && companyName !== '') {
                return collection.filter(function(item) {
                    return item.companyNamnes.includes(String(companyName));
                });
            }
        }

        return collection;
    }

    function isInputReadOnly(editPropertyName, groupRow){
        if(!vm.checkResults) return false
        if(editPropertyName === 'externalSku'){
            var alreadyExistingVariant = vm.checkResults.find(x => x.externalSku === groupRow.externalSku)
            if (alreadyExistingVariant && alreadyExistingVariant.externalSkuExists) {
                return true;
            }
        }
        return false
    }

    function cleanBarcodes() {
        // vm.importFile.importRows;
        _.forEach(vm.importFile.importRows, function(row) {
            row.barcode = removeDisallowedCharacters(row.barcode);
            row.isPristine = false;
        });

        _.forEach(vm.displayedGroups, function(group) {
            group.barcode = removeDisallowedCharacters(group.barcode);
        });
    }

    function removeDisallowedCharacters(string) {
        return string.replace(/[^a-zA-Z0-9-]/g, '');
    }

    function setGridColumnIdentifiers() {
        vm.gridColumnIdentifiers = [];

        vm.gridColumnIdentifiers.push({ label: '',                                 /* Has no edit property */                    inputElementType: 'refresh'       /* Has no selection elements */ });
        if (vm.importFile.importType === 'order') {
            vm.gridColumnIdentifiers.push({ label: 'order.ordernumber',            editPropertyName: 'orderNumberExternal',      inputElementType: 'string'        /* Has no selection elements */ });
            vm.gridColumnIdentifiers.push({ label: 'order.destination',            editPropertyName: 'locationCode',             inputElementType: 'string'        /* Has no selection elements */ });
        }
        vm.gridColumnIdentifiers.push({ label: 'article.alternativearticlenumber', editPropertyName: 'alternativeArticleNumber', inputElementType: 'string'        /* Has no selection elements */ });
        vm.gridColumnIdentifiers.push({ label: 'article.articlename',              editPropertyName: 'articleName',              inputElementType: 'string'        /* Has no selection elements */ });
        vm.gridColumnIdentifiers.push({ label: 'article.descriptionShort',         editPropertyName: 'articleDescription',       inputElementType: 'string'        /* Has no selection elements */ });
        vm.gridColumnIdentifiers.push({ label: 'article.itemgroup',                editPropertyName: 'itemGroupCode',            inputElementType: 'textdropdown', selectionElements: []           });
        vm.gridColumnIdentifiers.push({ label: 'article.variantdetail1',           editPropertyName: 'variant1Name',             inputElementType: 'string'        /* Has no selection elements */ });
        vm.gridColumnIdentifiers.push({ label: 'article.variantdetail2',           editPropertyName: 'variant2Name',             inputElementType: 'string'        /* Has no selection elements */ });
        vm.gridColumnIdentifiers.push({ label: 'article.department',               editPropertyName: 'departmentCode',           inputElementType: 'textdropdown', selectionElements: []           });

        if (vm.importFile.importType === 'order') {
            vm.gridColumnIdentifiers.push({ label: 'article.totalquantity',        editPropertyName: 'quantity',                 inputElementType: 'string'        /* Has no selection elements */ });
        }

        vm.gridColumnIdentifiers.push({ label: 'article.purchasecost',             editPropertyName: 'purchaseCost',             inputElementType: 'price'        /* Has no selection elements */ });
        vm.gridColumnIdentifiers.push({ label: 'article.salesprice',               editPropertyName: 'salesPrice',               inputElementType: 'price'        /* Has no selection elements */ });
        vm.gridColumnIdentifiers.push({ label: 'article.previousprice',            editPropertyName: 'previousPrice',            inputElementType: 'price'        /* Has no selection elements */ });
        vm.gridColumnIdentifiers.push({ label: 'article.subcategory',              editPropertyName: 'subCategory',              inputElementType: 'textdropdown', selectionElements: []           });
        vm.gridColumnIdentifiers.push({ label: 'article.articletype',              editPropertyName: 'articleTypeName',          inputElementType: 'textdropdown', selectionElements: []           });
        vm.gridColumnIdentifiers.push({ label: 'article.intrastatnumber',          editPropertyName: 'intrastatCode',            inputElementType: 'string'        /* Has no selection elements */ });
        vm.gridColumnIdentifiers.push({ label: 'article.barcode',                  editPropertyName: 'barcode',                  inputElementType: 'string'        /* Has no selection elements */ });

        if(vm.isAllowedToImportSku){
            vm.gridColumnIdentifiers.push({ label: 'productimport.externalSku',        editPropertyName: 'externalSku',              inputElementType: 'string'        /* Has no selection elements */ });
        }
        
        vm.gridColumnIdentifiers.push({ label: 'productimport.supplierSku',        editPropertyName: 'supplierSku',              inputElementType: 'string'        /* Has no selection elements */ });
        vm.gridColumnIdentifiers.push({ label: 'article.countryCode',              editPropertyName: 'countryCode',              inputElementType: 'textdropdown', selectionElements: []           });

        vm.gridColumnIdentifiers.push({ label: 'order.collection',                 editPropertyName: 'articleCollectionCode',    inputElementType: 'textdropdown', selectionElements: []           });

        if (vm.importFile.importType === 'order') {
            vm.gridColumnIdentifiers.push({ label: 'common.orderCollection',       editPropertyName: 'orderCollectionCode',      inputElementType: 'textdropdown', selectionElements: []           });
        }

        vm.gridColumnIdentifiers.push({ label: 'productimport.companyCode',        editPropertyName: 'companyCode',              inputElementType: 'textdropdown', selectionElements: []           });
        vm.gridColumnIdentifiers.push({ label: 'article.length',                   editPropertyName: 'length',                   inputElementType: 'string'        /* Has no selection elements */ });
        vm.gridColumnIdentifiers.push({ label: 'article.height',                   editPropertyName: 'height',                   inputElementType: 'string'        /* Has no selection elements */ });
        vm.gridColumnIdentifiers.push({ label: 'article.width',                    editPropertyName: 'width',                    inputElementType: 'string'        /* Has no selection elements */ });
        vm.gridColumnIdentifiers.push({ label: 'article.weight',                   editPropertyName: 'weight',                   inputElementType: 'string'        /* Has no selection elements */ });

        vm.gridColumnIdentifiers.push({ label: 'import.removerow',                 /* Has no edit property */                    inputElementType: 'delete'        /* Has no selection elements */ });
    }

}
